import { Component, OnInit, OnDestroy, ViewChild } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Router } from "@angular/router";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import {
  PoBreadcrumb,
  PoCheckboxComponent,
  PoCheckboxGroupComponent,
  PoCheckboxGroupOption,
  PoDialogService,
  PoModalComponent,
  PoNotificationService,
  PoPageAction,
  PoPageFilter,
  PoPageListComponent,
  PoTableAction,
  PoTableColumn,
  PoTableColumnLabel,
  PoTableColumnSpacing,
  PoTableComponent,
} from "@po-ui/ng-components";
import { environment } from "../../../environments/environment";
import { SchemaBuilderService } from "../../core/menu/schema-builder.service";
import { RpaService } from "../../core/rpa/rpa.service";
import { EmpresaRpaDto } from "../../models/Empresas/empresa-rpa-dto";
import { ShortcutService } from "../../core/shortcut/shortcut.service";
import { Subscription } from "rxjs";
import { PendenciasService } from "../pendencias/pendencias.service";
import { COMPETENCIA_RELATORIO_OPTIONS } from "../rpas/rpa-relatorio-pendencias.config";
@Component({
  selector: 'app-empresa',
  templateUrl: './empresa.component.html',
  styleUrl: './empresa.component.css',
  standalone: false
})
export class EmpresaComponent implements OnInit, OnDestroy {

  @ViewChild('modalRpa') poModalComponent!: PoModalComponent;
  @ViewChild('modalEmpresaRpa') poModalEmpresaComponent!: PoModalComponent;
  @ViewChild('modalCndRpa') poModalCndComponent!: PoModalComponent;
  @ViewChild('modalPendencias') poModalPendenciasComponent!: PoModalComponent;
  @ViewChild('CndGroup') poCndCheckboxGroupComponent!: PoCheckboxGroupComponent;

  isLoading: boolean = false;
  isLoadingPendencias: boolean = false;
  pdfUrlPendencias: SafeResourceUrl | null = null;
  public readonly rpaColumns: Array<PoTableColumn> = [
    {
      property: 'id',
      width: '5%',
      label: 'ID',
      visible: false,
    },
    {
      property: 'key',
      label: 'Chave',
      type: 'columnTemplate',
    },
    {
      property: 'competencia',
      label: 'Competência',

    },
    {
      property: 'fileName',
      label: 'Nome do Arquivo',
    },
    {
      property: 'dataHoraProc',
      label: 'Processado em:',
      type: 'date',
      format: 'dd/MM/yyyy HH:mm',
    },
    {
      property: 'status',
      type: 'label',
      label: 'Status',
      width: '5%',
      labels: <Array<PoTableColumnLabel>>[
        {
          value: 'SUCCESS',
          color: 'color-10',
          label: 'Emitido',
          textColor: 'white',
          tooltip: 'Documento emitido com sucesso pelo sistema.'
        },
        {
          value: 'BLOQUED',
          color: 'color-07',
          label: 'Bloqueado',
          textColor: 'white',
          tooltip: 'Não foi possível emitir o documento.'
        },
        {
          value: 'UNEXPECTED',
          color: 'color-08',
          label: 'Erro',
          textColor: 'white',
          tooltip: 'Não foi possível emitir o documento.'
        },
        {
          value: 'INVALID_CNPJ',
          color: 'color-05',
          label: 'CNPJ Inválido',
          textColor: 'white',
          tooltip: 'Não foi possível emitir o documento.'
        }
      ]
    }
  ];

  readonly rpaActions: PoTableAction[] = [
    {
      label: '(Ctrl + V) Visualizar Arquivo',
      action: this.showRpaFile.bind(this),
      icon: 'an an-check-circle',

    },
    {
      label: '(Ctrl + R) Reprocessar Arquivo',
      action: this.showRpaFile.bind(this),
      icon: 'an an-check-circle',
    }
  ];

  //RPA pagnation
  rpaMoreItens: boolean = false;
  rpaTableItens: any[] = [];
  poTableColumnSpacing: PoTableColumnSpacing = PoTableColumnSpacing.Small;

  // Listagem principal
  @ViewChild('dynamicTable', { static: true }) dynamicTable!: PoTableComponent;
  @ViewChild('pageListComponent', { static: true }) pageListComponent!: PoPageListComponent;
  isHideLoading = true;
  items: any[] = [];
  columns: Array<PoTableColumn> = [];
  moreItens: boolean = false;
  page: number = 1;
  pageSize: number = 15;
  filter: string = '';
  situacaoFiltro: string = 'ativa';
  readonly situacaoOptions: Array<{ label: string; value: string }> = [
    { label: 'Ativas', value: 'ativa' },
    { label: 'Inativas', value: 'inativa' },
    { label: 'Todas', value: 'todas' }
  ];
  disclaimerGroup: any;
  private disclaimers: any[] = [];
  private shortcutSubscription!: Subscription;
  public readonly filterSettings: PoPageFilter = {
    action: this.filterAction.bind(this),
    placeholder: 'Pesquisar'
  };

  //Empresa RPA Reports
  tipoCertidao: string = '';
  cidade: string = 'SANTO ANDRE';
  competencia: string = '';
  tipoFiltro: string = '0';
  cidadesOptions: Array<{ label: string; value: string }> = [];
  readonly competenciaOptions = COMPETENCIA_RELATORIO_OPTIONS;

  selectEmpresa: any;
  loading = false;
  editClient: any;
  readonly serviceApi = environment.apiUrl + '/v1/empresas';

  readonly breadcrumb: PoBreadcrumb = {
    items: [{ label: 'Home', link: '/home' }, { label: 'Cadastros' }, { label: 'Cadastro de Empresas', link: 'empresa' }]
  };

  readonly pageActions: Array<PoPageAction> = [
    {
      label: 'Nova Empresa',
      action: () => this.router.navigate(['/empresa-edit']),
      icon: 'an an-plus'
    },
    {
      label: 'Atualizar',
      action: () => this.resetTable(),
      icon: 'an an-arrows-clockwise'
    },
    {
      label: 'Relatórios',
      icon: 'an an-newspaper',
      action: this.showEmpresaRpaModal.bind(this)
    }
  ];

  readonly actions: PoTableAction[] = [
    {
      label: 'Editar Registro',
      action: this.edit.bind(this),
      icon: 'an an-pencil',
      type: 'default'
    },
    {
      label: 'Deletar Registro',
      action: this.confirmDelete.bind(this),
      icon: 'an an-trash',
      type: 'danger',
      separator: true
    },
    {
      label: 'Processar Certid\u00f5es',
      icon: 'an an-gear',
      action: this.requestCndDtniSp.bind(this)
    },
    {
      label: 'Visualizar Arquivos Dispon\u00edveis',
      icon: 'an an-folder',
      action: this.showRpaModal.bind(this)
    },
    {
      label: 'Emitir Relatório de Pendências',
      icon: 'an an-computer-tower',
      action: this.PendenciasModal.bind(this)
      
    },
    {
      label: 'Sincronizar Cadastro',
      icon: 'an an-cloud-check',
      action: this.sincronizaCadastro.bind(this)
    }
  ];

  public readonly systemOptions: Array<PoCheckboxGroupOption> = [

    { value: '1', label: 'CND - Dívida Ativa (Não Inscritos)' },
    { value: '2', label: 'CND - Dívida Ativa (Inscritos)' },
    { value: '3', label: 'CND - Trabalhista', },
    { value: '4', label: 'CND - Municipal' },
    { value: '5', label: 'CND - FGTS' },
    { value: '6', label: 'CND - Federal', disabled: true }

  ];


  constructor(private readonly schemaBuilderService: SchemaBuilderService,
    private readonly poNotificationService: PoNotificationService,
    private readonly rpaService: RpaService,
    private readonly poDialogService: PoDialogService,
    private readonly shortcutService: ShortcutService,
    private readonly router: Router,
    private readonly http: HttpClient,
    private readonly pendenciasService: PendenciasService,
    private readonly sanitizer: DomSanitizer) {
    this.schemaBuilderService.getTableSchema("empresa").subscribe((data) => {
      this.columns = this.transformTableSchema(data as any[]);
    });
    this.shortcutSubscription = this.shortcutService.getShortcuts().subscribe((event: KeyboardEvent) => {
      if (event.ctrlKey && event.key === 'b') {
        event.preventDefault();
        this.router.navigate(['/empresa-edit']);
      } else if (event.ctrlKey && event.key === 'f') {
        event.preventDefault();
        this.pageListComponent.filterInput.nativeElement.focus();
      }
    });
  }

  ngOnInit() {
    this.disclaimerGroup = {
      title: 'Filtros:',
      disclaimers: [],
      change: this.onChangeDisclaimer.bind(this),
      remove: this.onClearDisclaimer.bind(this)
    };
    this.loadMore();
    this.loadCidades();
  }

  ngOnDestroy(): void {
    if (this.shortcutSubscription) {
      this.shortcutSubscription.unsubscribe();
    }
  }

  populateDisclaimers(filters: Array<any>) {
    const property = filters.length > 1 ? 'advanced' : 'search';
    this.disclaimers = filters.map(value => ({ value, property }));

    if (this.disclaimers && this.disclaimers.length > 0) {
      this.disclaimerGroup.disclaimers = [...this.disclaimers];
    } else {
      this.disclaimerGroup.disclaimers = [];
    }
  }

  filterAction(labelFilter: string | Array<string>) {
    const filter = typeof labelFilter === 'string' ? [labelFilter] : [...labelFilter];
    this.populateDisclaimers(filter);
    this.filter = filter.toString();
    this.loadMore(true);
  }

  confirmDelete(item: any) {
    this.poDialogService.confirm({
      title: 'Exclus\u00e3o de Registros',
      message: `Deseja realmente excluir o item selecionado?`,
      confirm: () => this.remove(item)
    });

  }

  remove(item: any) {
    this.isHideLoading = false;
    this.http.delete(`${this.serviceApi}/${item.id}`).subscribe(() => {
      this.dynamicTable.removeItem(item);
      this.isHideLoading = true;
    }, () => {
      this.isHideLoading = true;
    });
  }

  edit(item: any) {
    this.router.navigate(['/empresa-edit', item.id]);
  }

  resetTable() {
    this.loadMore(true);
  }

  onChangeDisclaimer(disclaimers: any) {
    this.disclaimers = disclaimers;
    this.loadMore(true);
  }

  onClearDisclaimer(disclaimers: any) {
    if (disclaimers.removedDisclaimer.property === 'search') {
      this.pageListComponent.clearInputSearch();
    }
    this.disclaimers = [];
    this.filter = '';
    this.loadMore(true);
  }

  onChangeSituacao(value: string): void {
    const novaSituacao = (value ?? '').toString().trim().toLowerCase();
    this.situacaoFiltro = novaSituacao || 'todas';
    this.loadMore(true);
  }

  private transformTableSchema(schema: any[]): PoTableColumn[] {
    return (schema ?? [])
      .filter(field => field.visible !== false && field.showInGrid !== false)
      .sort((a, b) => (a.gridOrder ?? a.order ?? 0) - (b.gridOrder ?? b.order ?? 0))
      .map(field => {
        const property = field.property as string;
        const column: PoTableColumn = {
          property,
          label: field.label
        };

        if (property?.toLowerCase() === 'situacao') {
          column.type = 'label';
          column.labels = [
            { value: 'Ativa', color: 'color-10', label: 'Ativa', textColor: 'white' },
            { value: 'Inativa', color: 'color-07', label: 'Inativa', textColor: 'white' },
            { value: 'ativa', color: 'color-10', label: 'Ativa', textColor: 'white' },
            { value: 'inativa', color: 'color-07', label: 'Inativa', textColor: 'white' }
          ];
          column.width = '10%';
          return column;
        }

        if (field.type) {
          const typeLower = String(field.type).toLowerCase();
          if (typeLower === 'datetime' || typeLower === 'date') {
            column.type = 'date';
            if (field.format) {
              column.format = field.format;
            }
          } else if (typeLower === 'number' || typeLower === 'int' || typeLower === 'integer') {
            column.type = 'number';
          } else if (typeLower === 'boolean' || typeLower === 'bool') {
            column.type = 'boolean';
          }
        }

        return column;
      });
  }

  private mapearEmpresa(item: any): any {
    const situacaoApi = (item?.situacao ?? item?.Situacao ?? '').toString().trim();
    const dataInativacao = item?.dataInativacao ?? item?.DataInativacao;
    const situacao = situacaoApi
      ? (situacaoApi.toLowerCase().startsWith('inativ') ? 'Inativa' : 'Ativa')
      : (dataInativacao ? 'Inativa' : 'Ativa');

    return {
      ...item,
      situacao
    };
  }

  private montarUrlListagem(): string {
    const params = new URLSearchParams({
      page: String(this.page),
      pageSize: String(this.pageSize)
    });

    if (this.filter) {
      params.set('search', this.filter);
    }

    const situacao = (this.situacaoFiltro ?? '').toString().trim().toLowerCase();
    if (situacao && situacao !== 'todas') {
      params.set('situacao', situacao);
    }

    return `${this.serviceApi}?${params.toString()}`;
  }

  loadMore(reset: boolean = false): void {
    this.isHideLoading = false;
    if (reset) {
      this.page = 1;
    }

    this.http.get<any>(this.montarUrlListagem()).subscribe((data) => {
      const mapped = (data.items ?? []).map((item: any) => this.mapearEmpresa(item));
      this.items = reset ? [...mapped] : [...this.items, ...mapped];
      this.moreItens = data.hasNext;
      this.page++;
      this.isHideLoading = true;
    }, () => {
      this.isHideLoading = true;
    });
  }

  showRpaFile(rpaFile: any) {
    const objectName = this.rpaService.resolverObjectNameArquivo(rpaFile);
    if (!objectName) {
      this.poNotificationService.warning('Arquivo ainda não disponível.');
      return;
    }
    this.rpaService.requestRpaUrlFile(objectName).subscribe({
      next: (response: any) => {
        const signedUrl = this.rpaService.extrairUrlAssinadaResposta(response);
        if (!signedUrl) {
          this.poNotificationService.error('A API não retornou a URL do arquivo.');
          return;
        }
        window.open(signedUrl, '_blank');
      },
      error: () => {
        this.poNotificationService.error('Erro ao carregar o arquivo.');
      }
    });
  }
  showRpaModal(empresa: any) {
    this.selectEmpresa = empresa;
    this.rpaTableItens = [];
    this.isLoading = true;
    this.rpaService.requestRpaFilesByEmpresa(empresa.id).subscribe(data => {
      this.rpaTableItens = data.items;
      this.isLoading = false;
    }, error => {
      this.isLoading = false;
    });
    this.poModalComponent.open();
  }
  PendenciasModal(empresa: any) {
    this.selectEmpresa = empresa;
    this.isLoadingPendencias = true;
    this.pdfUrlPendencias = null;

    this.poModalPendenciasComponent.open();
    
    // Chama a API para gerar o relatório
    this.gerarRelatorioPendencias(empresa);
  }

  private limparStringNumerica(valor: string): string {
    return valor.replace(/\D/g, '');
  }

  private gerarRelatorioPendencias(empresa: any) {
    const cnpjLimpo = this.limparStringNumerica(empresa.cnpj || empresa.id?.toString() || '');

    if (!cnpjLimpo) {
      this.isLoadingPendencias = false;
      this.poNotificationService.error('Não foi possível identificar o CNPJ ou ID da empresa.');
      return;
    }

    this.pendenciasService.gerarRelatorioPendencias(cnpjLimpo).subscribe({
      next: (response) => {
        this.isLoadingPendencias = false;
        
        // A API retorna diretamente a URL do PDF
        if (response && typeof response === 'string') {
          // Sanitiza a URL para uso seguro no iframe
          this.pdfUrlPendencias = this.sanitizer.bypassSecurityTrustResourceUrl(response);
        } else {
          this.pdfUrlPendencias = null;
          this.poNotificationService.warning('O relatório foi gerado, mas não foi possível exibir o PDF.');
        }
      },
      error: (error) => {
        this.isLoadingPendencias = false;
        this.pdfUrlPendencias = null;
        console.error('Erro ao gerar relatório:', error);
        
        // Tratamento específico para erro de conexão (status 0)
        if (error.status === 0) {
          this.poNotificationService.error('Não foi possível conectar ao servidor. Verifique se a API está rodando e se há problemas de CORS.');
          return;
        }
        
        // Tratamento específico para erro 500 (Internal Server Error)
        if (error.status === 500) {
          const errorMessage = error.error?.message || error.error?.title || 'Erro interno do servidor';
          this.poNotificationService.error(`Erro no servidor: ${errorMessage}. Verifique os logs do backend.`);
          return;
        }
        
        if (error.error?.message) {
          this.poNotificationService.error(error.error.message);
        } else if (error.error?.errors) {
          this.poNotificationService.error('Erro de validação. Verifique os dados informados.');
        } else {
          this.poNotificationService.error('Erro ao gerar o relatório. Por favor, tente novamente.');
        }
      }
    });
  }
  atualizarRpa() {

    this.isLoading = true;
    this.rpaService.requestRpaFilesByEmpresa(this.selectEmpresa.id).subscribe(data => {
      this.rpaTableItens = data.items;
      this.isLoading = false;
    }, error => {
      this.isLoading = false;
    });
  }

  sincronizaCadastro(empresa: any) {
    const cnpjSemMascara = empresa.cnpj.replace(/[.\-\/]/g, '');
    console.log('Sincronizando cadastro para a empresa:', cnpjSemMascara);
    this.rpaService.sincronizaCadastro(cnpjSemMascara).subscribe({
      next: () => {
        this.poNotificationService.success('Cadastro sincronizado com sucesso!');
      },
      error: (error) => {
        console.error('Erro ao sincronizar cadastro:', error);
        this.poNotificationService.error('Erro ao sincronizar cadastro.');
      }
    });
  }

  processaCnd() {
    const selectedValues: string[] = this.poCndCheckboxGroupComponent.checkedOptionsList;

    for (const value of selectedValues) {
      if (value === '1') {
        console.log('CND - Dívida Ativa (Não Inscritos)');
        this.rpaService.requestCndDtniSp(this.selectEmpresa.cnpj).subscribe(); // Call service for '1'
      } else if (value === '2') {
        console.log('CND - Dívida Ativa (Inscritos)');
        this.rpaService.requestCndDtSp(this.selectEmpresa.cnpj).subscribe();   // Call service for '2'
      } else if (value === '3') {
        console.log('CND - Trabalhista');
        this.rpaService.requestTrabalhista(this.selectEmpresa.cnpj).subscribe();
      } else if (value === '4') {
        console.log('CND - Municipal');
        this.rpaService.requestMun(this.selectEmpresa.cnpj, this.selectEmpresa.codMun, this.selectEmpresa.im).subscribe();
      } else if (value === '5') {
        console.log('CND - FGTS');
        this.rpaService.requestFgts(this.selectEmpresa.cnpj).subscribe();
      }
    }

    this.poNotificationService.success('Certidões solicitadas com sucesso!');
    //this.poCndCheckboxGroupComponent.checkedOptionsList = [];
    this.poModalCndComponent.close();

  }
  requestCndDtniSp(empresa: any) {
    this.selectEmpresa = empresa;
    this.poModalCndComponent.open();
  }

  base64ToArrayBuffer(base64: string): ArrayBuffer {
    const binaryString = window.atob(base64); // Decodifica a string base64
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes.buffer;
  }
  public onChangeCompetencia(event: string) {
    this.competencia = event;
  }
  public onChangeTipocertidao(event: string) {
    this.tipoCertidao = event;
  }
  public onChangeCidade(event: string) {
    this.cidade = event;
  }
  private loadCidades() {
    this.http.get<string[]>(`${this.serviceApi}/cidades`).subscribe({
      next: (cidades) => {
        this.cidadesOptions = cidades.map(cidade => ({
          label: cidade,
          value: cidade
        }));
        if (this.cidadesOptions.find(c => c.value === 'SANTO ANDRE')) {
          this.cidade = 'SANTO ANDRE';
        } else if (this.cidadesOptions.length > 0) {
          this.cidade = this.cidadesOptions[0].value;
        }
      },
      error: (error) => {
        this.poNotificationService.error('Erro ao carregar lista de cidades.');
      }
    });
  }

  private showEmpresaRpaModal() {
    this.poModalEmpresaComponent.open();
  }
  public geraReportEmpresaRpa() {
    if (!this.tipoFiltro || this.tipoCertidao === '' || this.competencia === '') {
      this.poNotificationService.warning('Preencha todos os campos para gerar o relatório.');
      return;
    }

    this.empresaRpaServiceReport(this.tipoCertidao, this.cidade, this.competencia, this.tipoFiltro);
  }

  private empresaRpaServiceReport(typeCnd: string, cidade: string, competencia: string, typeCndFiltred: string) {
    this.loading = true;
    this.rpaService.requestEmpresasRpa(typeCnd, cidade, competencia, typeCndFiltred, '0').subscribe(data => {

      this.exportToCsv(data, 'empresas_rpa');
      this.downloadArquivosLote(data);

    }, error => {
      this.loading = false;
      this.poNotificationService.error('Erro ao gerar relatório.');
    });

  }

  private exportToCsv(data: EmpresaRpaDto[], fileName: string): void {

    if (data.length === 0) {
      this.poNotificationService.warning('Nenhum dado encontrado para exportação.');
      return;
    }

    const csvData = this.convertToCsv(data);
    const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', `${fileName}_${new Date().getTime()}.csv`);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  private convertToCsv(data: EmpresaRpaDto[]): string {
    const header = Object.keys(data[0]).join(';') + '\n';
    const rows = data.map(row => Object.values(row).join(';')).join('\n');
    return header + rows;
  }

  downloadArquivos(typeCnd: string, cidade: string, competencia: string, typeCndFiltred: string) {
    this.loading = true;
    this.rpaService.requestEmpresasRpa(typeCnd, cidade, competencia, typeCndFiltred, '1').subscribe(response => {

      if (response.length === 0) {
        this.poNotificationService.warning('Nenhum arquivo encontrado para download.');
        this.loading = false;
        return;
      }

      this.downloadArquivosLote(response);
      this.loading = false;
    }, error => {
      this.poNotificationService.error('Erro ao gerar relatório.');
      this.loading = false;
    });
  }

  downloadArquivosLote(data: EmpresaRpaDto[]) {

    const objectNames = this.getRpaUrls(data);
    if (objectNames.length === 0) {
      this.poNotificationService.warning('Nenhum arquivo encontrado para download.');
      this.loading = false;
      return;
    }

    const batches = this.chunkArray(objectNames, 100);
    // Processar os lotes sequencialmente
    this.processBatches(batches);

  }

  private base64ToBlob(base64: string, fileType: string): Blob {
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    let returnType: string = 'application/pdf';

    if (fileType === '.png') {
      returnType = 'image/png';
    }

    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: returnType });
  }
  private async processBatches(batches: string[][]) {
    this.loading = true;

    for (let i = 0; i < batches.length; i++) {
      try {
        this.rpaService.baixarZipLoteStream(batches[i]).subscribe(blob => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = `documentos_${new Date().toISOString()}-${i}.zip`;
          a.click();
          window.URL.revokeObjectURL(url);
          this.loading = false;
        });
      } catch (error) {
        this.poNotificationService.error(`Erro ao processar o lote ${i + 1}.`);
      }
    }

    this.loading = false;
    this.poNotificationService.success('Download concluído com sucesso!');
  }

  private downloadBlob(blob: Blob, fileName: string) {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
  }

  private chunkArray(array: string[], size: number): string[][] {
    return Array.from({ length: Math.ceil(array.length / size) }, (_, i) =>
      array.slice(i * size, i * size + size)
    );
  }

  private getRpaUrls(data: EmpresaRpaDto[]): string[] {
    return data.map(item => item.rpaUrl || '')
      .filter(url => url && url.trim() !== '');  // Retorna a propriedade rpaUrl ou uma string vazia caso seja undefined
  }

}
